import { Box, DashboardModule, Text } from '@domain-group/suit-theme'

import useChartData from '@hooks/useChartData'

interface TemplateTasksOverviewProps {
  teamId: number,
}

const TemplateTasksOverview = (props: TemplateTasksOverviewProps) => {
  const { teamId } = props

  const chartDataPayload = useChartData('task_list_items_overview', {
    requestOptions: { team_id: teamId },
  })
  const { dataPayload, loading } = chartDataPayload || {}

  return (
    <DashboardModule boxProps={{ marginBottom: 0 }} loading={loading} title="Template Tasks">
      <Box flexDirection="column">
        <Box flexDirection="column" paddingX="large" marginTop="large">
          <Box alignItems="center" justifyContent="space-between">
            <Text color="bodyFontLightColor" fontSize="small">
              Assigned Tasks
            </Text>

            <Text fontSize="xxxlarge" color="darkGrey">
              {dataPayload?.data?.incomplete_count}
            </Text>
          </Box>
        </Box>

        <Box flexDirection="column" paddingX="large" marginTop="large">
          <Box alignItems="center" justifyContent="space-between">
            <Text color="bodyFontLightColor" fontSize="small">
              Overdue Tasks
            </Text>

            <Text fontSize="xxxlarge" color="darkGrey">
              {dataPayload?.data?.overdue_count}
            </Text>
          </Box>
        </Box>

        <Box flexDirection="column" paddingX="large" marginTop="large">
          <Box alignItems="center" justifyContent="space-between">
            <Text color="bodyFontLightColor" fontSize="small">
              Avg Completed per Day
            </Text>

            <Text fontSize="xxxlarge" color="darkGrey">
              {dataPayload?.data?.average_completed_per_day}
            </Text>
          </Box>
        </Box>
      </Box>
    </DashboardModule>
  )
}

export default TemplateTasksOverview
